<template>
  <div>
    <surveys-table
      surveyName="UAS7"
      surveyCode="UAS7"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_UAS7,
        viewDetail: permissions.SEE_DETAIL_SURVEY_UAS7,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
